import React, { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [login, setLogin] = useState({ isLogin: false, token: null, user: {} });

  return (
    <AppContext.Provider
      value={{
        login,
        setLogin
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
